import api from './api';

export const chatService = {
  async getMessages(projectId, params = {}) {
    try {
      const response = await api.get(`/chat/project/${projectId}`, {
        params,
        silent: true // Suppress console errors for this request
      });
      return response.data;
    } catch (error) {
      // Re-throw error but it will be handled silently by the interceptor
      throw error;
    }
  },

  async sendMessage(projectId, content, attachments = null, mentions = []) {
    const formData = new FormData();
    formData.append('content', content);

    if (mentions.length > 0) {
      formData.append('mentions', JSON.stringify(mentions));
    }

    if (attachments) {
      for (const file of attachments) {
        formData.append('attachments', file);
      }
    }

    const response = await api.post(`/chat/project/${projectId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      silent: true // Suppress console errors for this request
    });
    return response.data.data;
  },

  async editMessage(messageId, content) {
    const response = await api.patch(`/chat/messages/${messageId}`, { content });
    return response.data.data;
  },

  async deleteMessage(messageId) {
    const response = await api.delete(`/chat/messages/${messageId}`);
    return response.data;
  },

  async markAsRead(projectId) {
    const response = await api.post(`/chat/project/${projectId}/mark-read`);
    return response.data;
  },

  async getUnreadCount() {
    const response = await api.get('/chat/unread');
    return response.data.data;
  }
};
